var _path, _path2, _g, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 55,
    viewBox: "0 0 60 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 0C46.5685 0 60 13.5262 60 30.0947C59.9999 34.6259 58.993 38.9284 57.1943 42.79C50.1391 44.2214 41.5377 46.6822 35.8301 50.7666C28.7231 55.8526 17.8089 54.7071 10.7959 53.1973C4.19877 47.6683 0.000116991 39.3574 0 30.0947C0 13.5262 13.4315 0 30 0Z",
    fill: "#F0F6FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_338_5838",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 55
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30 0C46.5685 0 60 13.5262 60 30.0947C59.9999 34.6259 58.993 38.9284 57.1943 42.79C50.1391 44.2214 41.5377 46.6822 35.8301 50.7666C28.7231 55.8526 17.8089 54.7071 10.7959 53.1973C4.19877 47.6683 0.000116991 39.3574 0 30.0947C0 13.5262 13.4315 0 30 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_338_5838)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 12.1489L17.5 16.6489V25.7839C17.5 33.3589 22.615 40.4239 29.5 42.1489C36.385 40.4239 41.5 33.3589 41.5 25.7839V16.6489L29.5 12.1489ZM27.91 32.4589L22.6 27.1489L24.715 25.0339L27.895 28.2139L34.255 21.8539L36.37 23.9689L27.91 32.4589Z",
    fill: "#0C6DB0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/Time.09b09f67583221596921422faabc7a4d.svg";
export { ForwardRef as ReactComponent };